import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { deletionQuery } from '../../shared/api/deletion-queries.js';

/**
 * Shown on every page to every member while the business is scheduled for
 * deletion. A deletion nobody was told about is the one failure the whole
 * thirty-day design exists to prevent.
 */
export function DeletionBanner({ organizationId }: { organizationId: string }) {
  const pending = useQuery({ ...deletionQuery(organizationId), enabled: organizationId !== '' });
  if (pending.data === undefined || pending.data === null) return null;
  return (
    <div
      role="alert"
      className="mb-6 rounded-[var(--radius-control)] border border-danger/30 bg-danger/10 px-4 py-3 text-sm text-danger"
    >
      This business and all its data will be deleted on{' '}
      {new Date(pending.data.purgeAfter).toLocaleDateString('en-CA')}.{' '}
      <Link to="/settings" className="font-medium underline">
        Export or cancel
      </Link>
    </div>
  );
}
